const styles = {
  container: {
    height: '100vh',
  },
  contentContainer: {},
};

export default styles;
